import { NavLink, withRouter } from 'react-router-dom'
import React from 'react'
import { TableVirtualized } from '../root/components/common/table-virtualized/table'
import Icon from '@mdi/react'
import {
    mdiQrcodeScan,
    mdiAlertRemoveOutline,
    mdiTrashCanOutline
} from '@mdi/js'
import { getDeviceStatusTooltipText } from '../../utils'
import { DeviceStatus, Tooltip } from '../root/components/common'
import { useSelector } from 'react-redux'
import { IconButton, makeStyles, Typography } from '@material-ui/core'
import { Highlighted } from '../root/components/common/highlighted'
import classNames from 'classnames'
import { UserPermissions } from '../../services/permissions'
import { REPLACEMENT_STATUSES, REPLACEMENT_STATUSES_DE } from './constants'

const useStyles = makeStyles(theme => ({
    disabled: {
        '&&': {
            color: theme.quaternary
        }
    },
    disabledImage: {
        filter: 'opacity(0.2)'
    },
    nameLink: {
        marginRight: 8,
        color: theme.textPrimary,
        textDecoration: 'none',
        fontWeight: 'bold',
        cursor: 'pointer',
        '&:hover': {
            opacity: 0.3
        }
    },
    batteryWrapper: {
        alignItems: 'center',
        display: 'flex'
    },
    wifiWrapper: {
        display: 'flex',
        flex: 1,
        justifyContent: 'flex-end'
    },
    lastColumn: {
        display: 'flex',
        flex: 1,
        justifyContent: 'flex-end'
    },
    statusWrapper: {
        display: 'flex',
        justifyContent: 'center'
    },
    qrIcon: {
        cursor: 'pointer',
        marginRight: 8,
        '&:hover': {
            opacity: 0.3
        }
    },
    restoreIconButton: {
        color: theme.primary
    },
    deviceStatusShortText: {
        marginLeft: 4
    },
    assignmentRowBlocker: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: theme.background,
        opacity: 0.5
    }
}))

const SwapReplacementsTableComponent = ({
    onQrIconClick,
    swapReplacements,
    isLoading,
    isLoadingMore,
    onLoadMore,
    sorting,
    onSort,
    search,
    history,
    onRowClick,
    removeReplacementDevice
}) => {
    const {
        theme,
        locale,
        user: { original_role }
    } = useSelector(state => state.main)

    const classes = useStyles()

    const Link = prop => <NavLink target={'_blank'} {...prop} />

    const handleLinkClick = e => {
        e.stopPropagation()
    }

    const onRowClickInner = rowObj => {
        onRowClick(rowObj.rowData.id)
    }

    const onReplacementRemoveIconClick = sRId => {
        removeReplacementDevice(sRId)
    }

    const columns = [
        {
            key: 'customer_device_serial_number',
            label: 'Gerät des Kunden',
            sortable: false,
            dataType: 'string',
            width: 3,
            render: ({ rowData, cellData }) => {
                const statusTooltipText = getDeviceStatusTooltipText(locale, {
                    data: null,
                    report_type: rowData.cd_last_report_type
                })
                const isStatusIconWithTooltip = statusTooltipText !== null
                return (
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Icon
                                path={mdiQrcodeScan}
                                size={0.8}
                                color={theme.primary}
                                className={classes.qrIcon}
                                onClick={e => {
                                    e.stopPropagation()
                                    onQrIconClick(
                                        rowData['customer_device_serial_number']
                                    )
                                }}
                            />
                            <Link
                                onClick={handleLinkClick}
                                className={classNames(classes.nameLink)}
                                to={`/devices/${rowData.customer_device_id}`}
                            >
                                <Highlighted
                                    text={rowData.customer_device_serial_number}
                                    highlight={search}
                                />
                            </Link>
                            <Tooltip
                                hover
                                hideTooltip={!isStatusIconWithTooltip}
                                placement="top"
                                text={statusTooltipText}
                            >
                                <DeviceStatus
                                    value={rowData.cd_last_report_type}
                                />
                            </Tooltip>
                        </div>
                        <div>
                            <Typography noWrap variant="inherit">
                                ({rowData.cd_location_name})
                            </Typography>
                        </div>
                    </div>
                )
            }
        },
        {
            key: 'replacement_device_serial_number',
            label: 'Ersatzgerät',
            sortable: false,
            dataType: 'string',
            width: 3,
            render: ({ rowData, cellData }) => {
                if (!rowData.replacement_device_serial_number) {
                    return '--'
                }
                const statusTooltipText = getDeviceStatusTooltipText(locale, {
                    data: null,
                    report_type: rowData.rd_last_report_type
                })
                const isStatusIconWithTooltip = statusTooltipText !== null
                return (
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Icon
                                path={mdiQrcodeScan}
                                size={0.8}
                                color={theme.primary}
                                className={classes.qrIcon}
                                onClick={e => {
                                    e.stopPropagation()
                                    onQrIconClick(
                                        rowData[
                                            'replacement_device_serial_number'
                                        ]
                                    )
                                }}
                            />
                            <Link
                                onClick={handleLinkClick}
                                className={classNames(classes.nameLink)}
                                to={`/devices/${rowData.replacement_device_id}`}
                            >
                                <Highlighted
                                    text={
                                        rowData.replacement_device_serial_number
                                    }
                                    highlight={search}
                                />
                            </Link>
                            <Tooltip
                                hover
                                hideTooltip={!isStatusIconWithTooltip}
                                placement="top"
                                text={statusTooltipText}
                            >
                                <DeviceStatus
                                    value={rowData.rd_last_report_type}
                                />
                            </Tooltip>
                            {rowData.status !== REPLACEMENT_STATUSES.replaced &&
                            rowData.rd_last_report_type !== null &&
                            rowData.rd_last_report_type !== '12' ? (
                                <Tooltip
                                    hover
                                    placement="top"
                                    text={
                                        'Das Ersatzgerät muss ausgeschaltet sein'
                                    }
                                >
                                    <Icon
                                        style={{ marginLeft: 40 }}
                                        path={mdiAlertRemoveOutline}
                                        size={1}
                                        color={theme.error}
                                    />
                                </Tooltip>
                            ) : null}
                            {[
                                REPLACEMENT_STATUSES.replacement_scanned,
                                REPLACEMENT_STATUSES.replacement_scanned_again,
                                REPLACEMENT_STATUSES.replace_cancelled
                            ].includes(rowData.status) ? (
                                <IconButton
                                    onClick={e => {
                                        e.stopPropagation()
                                        onReplacementRemoveIconClick(rowData.id)
                                    }}
                                    style={{ marginLeft: 40 }}
                                    size="small"
                                >
                                    <Icon
                                        path={mdiTrashCanOutline}
                                        size={1}
                                        color={theme.primary}
                                    />
                                </IconButton>
                            ) : null}
                        </div>
                        <div>
                            <Typography noWrap variant="inherit">
                                ({rowData.rd_location_name})
                            </Typography>
                        </div>
                    </div>
                )
            }
        },
        {
            key: 'customer_name',
            label: 'Kunde',
            sortable: false,
            dataType: 'string',
            width: 1,
            render: ({ rowData, cellData }) => rowData.customer_name
        },
        {
            key: 'status',
            label: 'Status',
            sortable: false,
            dataType: 'string',
            width: 1,
            render: ({ rowData, cellData }) =>
                REPLACEMENT_STATUSES_DE[rowData.status]
        }
    ]

    return (
        <TableVirtualized
            data={swapReplacements}
            isLoadingMore={isLoadingMore}
            isLoading={isLoading}
            onLoadMore={onLoadMore}
            columns={columns}
            sorting={sorting}
            onSort={onSort}
            onRowClick={onRowClickInner}
        />
    )
}

const SwapReplacementsTable = withRouter(SwapReplacementsTableComponent)
export { SwapReplacementsTable }
